const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoingeckoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_1000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_327_1000",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 26,
    height: 26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 15H15V41H41V15Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_327_1000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0331 15.0001C20.9046 15.0327 15.1522 20.8788 15.1837 28.0584C15.2161 35.238 21.0215 41.0316 28.1491 40.9999C35.2777 40.9673 41.0301 35.1212 40.9986 27.9425C40.9662 20.762 35.1617 14.9684 28.0331 15.0001ZM26.3987 27.3627C25.1241 27.3627 24.0906 26.3226 24.0906 25.0389C24.0906 23.7552 25.1241 22.7152 26.3987 22.7152C27.6733 22.7152 28.706 23.7561 28.706 25.0389C28.706 26.3217 27.6724 27.3627 26.3987 27.3627ZM28.2391 29.8748L28.2508 29.8604L28.2634 29.8459C28.9218 30.2735 29.6738 30.4248 30.4249 30.4465C31.1769 30.4664 31.9433 30.4094 32.6971 30.2563C33.4499 30.0986 34.1902 29.8658 34.9053 29.5686C35.3065 29.4019 35.7059 29.2199 36.0864 29.0061C36.0891 29.0042 36.0909 29.0033 36.0936 29.0015C36.3302 28.8584 36.5613 28.7071 36.788 28.5513C36.8374 28.5159 36.8851 28.4788 36.9319 28.4408L36.9373 28.4471L36.9571 28.4706C36.3769 29.0024 35.6861 29.3974 34.9827 29.7462C34.2721 30.0832 33.5309 30.3595 32.7654 30.5588C32.0026 30.7572 31.2066 30.9076 30.4006 30.8333C29.6073 30.7627 28.7716 30.4828 28.2373 29.8758L28.2391 29.8748ZM34.1615 27.3627C34.1605 27.0836 34.3836 26.859 34.6589 26.8562C34.9359 26.8553 35.159 27.0791 35.1617 27.3572C35.1626 27.6353 34.9395 27.8627 34.6643 27.8637C34.3881 27.8646 34.1641 27.6399 34.1615 27.3627ZM30.2081 39.8312C29.7098 36.3134 32.76 32.8681 34.4799 31.1051C34.8703 30.7056 35.4738 30.1548 36.0351 29.5696C38.2677 27.4669 38.712 24.9547 34.1425 23.699C33.2763 23.4463 32.3786 23.0884 31.4692 22.7269C31.4404 22.6427 31.4081 22.563 31.3703 22.4878C31.2659 22.3066 31.0834 22.0982 30.8072 21.8618C30.2135 21.3426 29.0972 21.3562 28.1339 21.5864C27.0689 21.3336 26.0182 21.2439 25.0081 21.4876C20.5888 22.7143 19.8782 24.8849 19.7064 27.5004C19.4726 30.3269 19.3358 32.4332 18.2735 34.8394C16.9477 32.9134 16.166 30.577 16.1552 28.0557C16.1255 21.4169 21.4451 16.0112 28.0367 15.9813C34.6283 15.9514 39.9956 21.3091 40.0253 27.9479C40.0523 33.8773 35.8102 38.8247 30.2072 39.833L30.2081 39.8312Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0217 25.0598C28.0217 25.963 27.2949 26.6941 26.399 26.6941C25.5031 26.6941 24.7754 25.963 24.7754 25.0598C24.7754 24.1565 25.5022 23.4255 26.399 23.4255C27.2958 23.4255 28.0217 24.1565 28.0217 25.0598Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_1000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(15 15)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoingeckoIcon);
export default __webpack_public_path__ + "static/media/coingecko-icon.7f8babe5183d89ffeda2b23fca813adf.svg";
export { ForwardRef as ReactComponent };